export default {
  name: 'benefits',
  data () {
    return {
      label: 'BENEFITS',
      componentValue: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    componentValue: function () {
      this.$emit('input', this.componentValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/benefits/script.js